<template>
  <div class="multi">
    <p class="multi-title">
      <span v-html="surveyQuestion.longCaption" />
    </p>
    <div class="multi-content">
      <checkbox
        class="multi-checkbox"
        v-for="(opt, index) in surveyQuestion.responses"
        :key="index"
        :value="false"
        :text="opt.caption"
        @input="onInput($event, index)"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Checkbox from '../../common/Checkbox'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'Multi',
  components: {
    Checkbox,
  },
  data() {
    return {
      selectedAnswers: [],
    }
  },
  computed: {
    ...mapGetters(['surveyQuestion']),
  },
  created() {
    this.setInputName('multi')
  },
  methods: {
    ...mapActions(['setAnswer', 'setInputName']),
    onInput(event, index) {
      this.selectAnswer(event, index)
      this.$emit('setValid', true)
    },
    selectAnswer(state, i) {
      if (state) {
        this.selectedAnswers.push({
          inputName: this.surveyQuestion.responses[i].inputName,
          value: '1',
        })
      } else {
        this.selectedAnswers.map((answer, index) => {
          if (answer.inputName === this.surveyQuestion.responses[i].inputName) {
            this.selectedAnswers.splice(index, 1)
          }
        })
      }

      this.setAnswer(this.selectedAnswers)
    },
  },
}
</script>

<style scoped lang="postcss">
.multi {
  &-title {
    text-align: left;
  }
  &-content {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  &-checkbox {
    padding-top: 10px;
  }
}
</style>
